import React, { useEffect, useState, useCallback } from 'react';
import LaboralBulkLoadHiringFileInput from './file_input';
import LaboralBulkLoadHiringListHidden from './list_hidden';
import LaboralBulkLoadHiringTableErrors from './table_errors';
import LaboralBulkLoadHiringTable from './table';
import { FormGroup, Button, UncontrolledTooltip, Label } from 'reactstrap';
import swal from "sweetalert2";
import moment from 'moment';
import _ from 'lodash-es';
import { formatToCurrency } from "../../../../helper/form";

const LaboralBulkLoadHiringForm = ({ companies, employees, defaultHeaders, customFieldsHeaders, currentUser }) => {
  const formName = 'laboral_bulk_load_hiring'
  const [hiringBulk, setHiringBulk] = useState([])
  const [hiringBulkErrors, setHiringBulkErrors] = useState([])
  const [employeesSelect, setEmployeesSelect] = useState([])
  const [branchSelect, setBranchSelect] = useState([])
  const [dataHidden, setDataHidden] = useState([])
  const [updateHiring, setUpdateHiring] = useState(false)
  const [disabledSubmitButton, setDisabledSubmitButton] = useState(false)
  const _controldoc_id = 'controldoc_id'
  const _headers_concat = _.concat(defaultHeaders, _.map(customFieldsHeaders, 'code'), _controldoc_id)
  // se excluye el primer elemento ya que ahora se posiciona al final del arreglo
  const headers = _.slice(_headers_concat, 1, _headers_concat.length)

  useEffect(() => {
    setDataHidden(hiringBulk)
  }, [hiringBulk])

  useEffect(() => {
    if (updateHiring) {
      setHiringBulk(hiringBulk)
      setUpdateHiring(false)
    }
  }, [updateHiring])

  const onChangeCellValues = (value, row, key, customField) => {
    if (!value) {
      return;
    }

    if (customField?.data_type == 'currency') {
      value = formatToCurrency(value)
    }

    if (customField?.data_type == 'date') {
      // se convierte a formato DD/MM/YYYY para que al cargar los campos
      // los vuelva a transformar a YYYY-MM-DD y asi no se pierde el formato para mostrarlo
      value = moment(value, "YYYY-MM-DD").locale('es').format('DD/MM/YYYY')
    }

    setHiringBulk(prevData => {
      const newData = [...prevData];
      const itemIndex = newData.findIndex(item => item.uniqueId === row.uniqueId);
      if (itemIndex !== -1) {
        newData[itemIndex] = { ...newData[itemIndex], [key]: value };
      }
      return newData;
    });

    setUpdateHiring(true)
  }

  const renderActions = (rowData) => {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Button
          color="danger"
          outline
          className="border-0"
          onClick={(e) => handleDestroyHiring(rowData)}
        >
          <i className="fas fa-trash-alt" />
        </Button>
        {iconNewHiring(rowData)}
      </div>
    );
  }

  const iconNewHiring = (row) => {
    if (row.controldoc_id == "") {
      return (
        <div className="d-inline-block m-2">
          <span id="tooltipTonNewHiring">
            <i className="fas fa-folder-plus text-info" />
          </span>
          <UncontrolledTooltip key={_.uniqueId(row.id)} placement="bottom" target="tooltipTonNewHiring">
            Nueva contratación
          </UncontrolledTooltip>
        </div>
      )
    }
  }

  const validateItem = (item, row) => {
    return (
      item.row === row.row &&
      item.employee_id != "" &&
      item.company_id != "" &&
      item.start_date != "" &&
      moment(item.start_date, 'YYYY-MM-DD', true).isValid() &&
      (
        item.end_date == "" ||
        moment(item.end_date, 'YYYY-MM-DD', true).isValid() &&
        item.start_date < item.end_date
      )
    )
  }

  const handleValidateHiringId = (row) => {
    let addNewData = [];
    let filteredArray = [];

    _.each(hiringBulkErrors, function (item) {
      if (validateItem(item, row) && !isExistHiringId(item["hiring_id"]) || item["hiring_id"] == "" && validateItem(item, row)) {
        addNewData.push(item);
        swal.fire({
          icon: 'success',
          title: 'Genial',
          text: 'Fila corregida'
        })
        return true;
      } else if (validateItem(item, row)) {
        swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'El identificador de la contratación ya se encuentra en uso',
        })
      } else if (item.row === row.row) {
        swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Campos vacios verifique los datos',
        })
      }
      filteredArray.push(item)
    })
    setHiringBulkErrors(filteredArray);
    if (addNewData.length > 0) {
      let _hiringBulk = [...hiringBulk]
      _hiringBulk = _.concat(addNewData, hiringBulk)
      setHiringBulk(_hiringBulk);
    }
  }

  const handleDestroyHiring = (row) => {
    swal.fire({
      title: 'Eliminar fila',
      text: "Esta seguro de eliminar la fila",
      icon: 'warning',
      showCancelButton: true,
      customClass: {
        confirmButton: 'swal2-confirm btn btn-success ml-3',
        cancelButton: 'swal2-cancel btn btn-secondary'
      },
      buttonsStyling: false,
      confirmButtonText: "<i class='fa fa-thumbs-up'></i> Confirmar",
      cancelButtonText: "<i class='fa fa-thumbs-down'></i> Cancelar",
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        let _hiringBulk = [...hiringBulk]
        _.remove(_hiringBulk, item => { return item.uniqueId === row.uniqueId })
        setHiringBulk(_hiringBulk);
        swal.fire(
          'Eliminado!',
          'La fila ha sido elimina correctamente',
          'success'
        )
      }
    })
  };

  const isExistHiringId = (value, row = false) => {
    if (row) {
      let fil = _.filter(dataHidden, item => { return item.id != row.id })
      return !!_.find(fil, { "hiring_id": value })
    } else {
      return !!_.find(dataHidden, { "hiring_id": value })
    }
  }

  const drawHiringBulk = () => {
    if (hiringBulk?.length > 0) {
      return (
        <LaboralBulkLoadHiringTable
          data={hiringBulk}
          dataKey="uniqueId"
          employeesSelect={employeesSelect}
          branchSelect={branchSelect}
          customFieldsHeaders={customFieldsHeaders}
          currentUser={currentUser}
          actionsRenderer={renderActions}
          onDataChange={onChangeCellValues}
          title={<Label>Registros ({hiringBulk?.length}):</Label>}
        />
      )
    }
  }

  const handleConfirmSubmit = (e) => {
    e.preventDefault();
    swal.fire({
      title: 'Realizar carga masiva de contrataciones',
      html: '¿Estás seguro de realizar la carga masiva?',
      cancelButtonText: "<i class='fa fa-thumbs-down'></i> Cancelar",
      confirmButtonText: "<i class='fa fa-thumbs-up'></i> Confirmar",
      reverseButtons: true,
      showCancelButton: true,
      customClass: {
        confirmButton: 'btn btn-success ml-3',
        cancelButton: 'btn btn-secondary'
      },
      buttonsStyling: false,
    }).then(result => {
      if (result.isConfirmed) {
        let _form = document.getElementById("new_laboral_bulk_load_hiring")
        setDisabledSubmitButton(true)
        _form.submit()
      }
    })
  }

  const drawTextSubmitButton = () => {
    if (disabledSubmitButton) {
      return I18n.t('actions.saving')
    } else {
      return I18n.t('actions.save')
    }
  }

  const drawBtnSubmit = () => {
    if (hiringBulk?.length > 0) {
      return (
        <button
          type='submit'
          className='btn btn-success ml-2'
          onClick={e => handleConfirmSubmit(e)}
          disabled={disabledSubmitButton}
        >
          {drawTextSubmitButton()}
        </button>
      )
    }
  }

  return (
    <div className="row">
      <form action={Routes.laboral_bulk_load_hirings_path()} encType="multipart/form-data" method="post" id="new_laboral_bulk_load_hiring">
        <input type="hidden" name="authenticity_token" value={window.compliance.token} />
        <div className="col-12">
          <LaboralBulkLoadHiringFileInput
            headers={headers}
            setHiringBulk={setHiringBulk}
            customFieldsHeaders={customFieldsHeaders || []}
            setHiringBulkErrors={setHiringBulkErrors}
            formName={formName}
            setBranchSelect={setBranchSelect}
            setEmployeesSelect={setEmployeesSelect}
          />
        </div>
        <div className="col-12">
          <LaboralBulkLoadHiringListHidden
            customFields={customFieldsHeaders || []}
            currentUser={currentUser}
            formName={formName}
            dataHidden={dataHidden}
          />
        </div>
        <div className="col-12">
          <LaboralBulkLoadHiringTableErrors
            customFieldsHeaders={_.map(customFieldsHeaders)}
            iconNewHiring={iconNewHiring}
            hiringBulk={hiringBulk}
            isExistHiringId={isExistHiringId}
            handleValidateHiringId={handleValidateHiringId}
            setHiringBulkErrors={setHiringBulkErrors}
            hiringBulkErrors={hiringBulkErrors}
            employeesSelect={employeesSelect}
            branchSelect={branchSelect}
            currentUser={currentUser}
          />
        </div>
        <div className="col-12">
          {drawHiringBulk()}
        </div>
        <FormGroup className='text-end'>
          <a
            href={Routes.laboral_bulk_load_hirings_path()}
            className='btn btn-default'
          >
            {I18n.t('actions.back')}
          </a>
          {drawBtnSubmit()}
        </FormGroup>
      </form>
    </div>
  )
}

export default LaboralBulkLoadHiringForm;
